export default "__VITE_ASSET__Bo_NxJ8p__"